import React, { useState, useEffect } from "react";
import { Plus, SquareChartGantt } from "lucide-react";

import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import AutomationCard from "../../components/automation/automation-card";
import ActionMenu from "../../components/automation/action-menu";
import SearchBar from "../../components/automation/search-bar";
import styles from "../../styles/automation-styles";

const descriptions = [
  "Esta regra é executada imediatamente quando um novo chamado é criado e atende às condições configuradas.",
  "Esta regra é executada instantaneamente sempre que um chamado existente é atualizado e cumpre as condições definidas na automação.",
  "Esta regra é executada de forma automatizada a cada hora. Ela verifica todos os chamados que se encaixam nas condições e dispara a ação configurada.",
];

// Main AutomationList Component
const AutomationList = (props) => {
  const [activeTab, setActiveTab] = useState(parseInt(localStorage.getItem("activeAutomationTab")) || 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [selectedAutomation, setSelectedAutomation] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    localStorage.setItem("activeAutomationTab", tabIndex);
  };

  const handleMenuOpen = (e, automation) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition({
      x: rect.left + window.scrollX - 150,
      y: rect.bottom + window.scrollY - 25,
    });
    setSelectedAutomation(automation);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // Get automations for current active tab and filter by search term
  const automations = (props.data[activeTab] || []).filter((automation) => {
    if (!searchTerm) return true;

    const searchLower = searchTerm.toLowerCase();
    return (
      automation.title.toLowerCase().includes(searchLower) ||
      automation.condition.toLowerCase().includes(searchLower)
    );
  });

  // Handle click outside menu to close it
  useEffect(() => {
    const handleClickOutside = () => {
      setMenuOpen(false);
    };

    if (menuOpen) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div style={styles.contentWrapper}>
      <h1 style={styles.heading}>Automações</h1>

      <div style={styles.tabContainer}>
        <div style={styles.tabRow}>
          <span style={styles.tabLabel}>Regras executadas em:</span>
          <div style={styles.tabsWrapper}>
            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 0 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(0)}
            >
              Criação De Tickets
              <span style={styles.tabCount}>{props.data[0]?.length}</span>
            </button>
            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 1 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(1)}
            >
              Atualizações De Tickets
              <span style={styles.tabCount}>{props.data[1]?.length}</span>
            </button>
            <button
              style={{
                ...styles.tabButton,
                ...(activeTab === 2 ? styles.activeTabButton : {}),
              }}
              onClick={() => handleTabClick(2)}
            >
              Acionadores Horários
              <span style={styles.tabCount}>{props.data[2]?.length}</span>
            </button>
          </div>
        </div>
        {/*<SearchBar onSearch={setSearchTerm} />*/}
      </div>

      <p style={styles.infoText}>
        {descriptions[activeTab] ?? descriptions[0]}
        <button style={styles.moreInfoButton}>Mais informações</button>
      </p>

      <div style={styles.actionsRow}>
        <Button
          style={styles.newRuleButton}
          component={Link}
          {...{
            to: `/${props.match.params.lang}/automation-registration?type=${
              activeTab + 1
            }`,
          }}
        >
          <Plus size={18} />
          <span>Nova regra</span>
        </Button>

        <Button
          style={styles.newRuleButton}
          component={Link}
          {...{
            to: `/${props.match.params.lang}/automation-templates`,
          }}
        >
          <SquareChartGantt size={18} />
          <span>Templates</span>
        </Button>
      </div>

      {automations.length > 0 ? (
        automations.map((automation) => (
          <AutomationCard
            key={automation.id}
            automation={automation}
            onMenuOpen={handleMenuOpen}
            updateActiveAsync={props.updateActiveAsync}
            getItemForUpdateAsync={props.getItemForUpdateAsync}
          />
        ))
      ) : (
        <div style={styles.emptyContainer}>
          <p style={styles.emptyText}>
            {searchTerm
              ? "Nenhuma automação encontrada com os termos de pesquisa."
              : "Não existem automações nesta categoria. Clique em 'Nova regra' para criar uma."}
          </p>
        </div>
      )}

      <ActionMenu
        isOpen={menuOpen}
        position={menuPosition}
        onClose={handleMenuClose}
        selectedAutomation={selectedAutomation}
        deleteAsync={props.deleteAsync}
        cloneItemAsync={props.cloneItemAsync}
        getItemForUpdateAsync={props.getItemForUpdateAsync}
      />
    </div>
  );
};
export default AutomationList;
